import { getAnalytics, logEvent, setUserProperties } from "firebase/analytics";
import {
  getAppBuildVersion,
  getAppSessionUuid,
  getPlatform,
  getWebAppVersion,
} from "./config";
import { GA_LABEL3, POST_TYPES } from "./constants";

export const triggerGa = ({
  category = "",
  action = "",
  label = "",
  label2 = "",
  label3 = "",
  page = "",
  screenName = "",
  eventValue = 0,
  custom = "",
  post_id = 0,
  collection_id = 0,
  product_id = 0,
}) => {
  if (!localStorage.adminToken) {
    const eventDetails = {
      event_category: category,
      event_label: label,
      event_location: window.location.pathname,
      event_label2: label2,
      event_label3: label3,
      page_title: page,
      screen_name: screenName,
      value: eventValue,
      custom_parameter: custom,
      post_id: post_id,
      collection_id: collection_id,
      product_id: product_id,
      platform: getPlatform(),
      app_build: getAppBuildVersion(),
      app_version: getWebAppVersion(),
      app_open_id: getAppSessionUuid(),
    };
    if (window.cordova) {
      window.FirebasePlugin?.logEvent(action, eventDetails);
      window.ga?.trackEvent(category, action, label);
    } else {
      // window.gtag("event", action, eventDetails);  // removed for setting up GA with firebase analytics for web as well
      const analytics = getAnalytics();
      logEvent(analytics, action, eventDetails);
    }
  }
};

export const triggerSlAuthResponse = ({
  category = "",
  action = "",
  platform = "", // ig/yt/fb/tg
  status = "", // success/fail
  failReason = "", // fail reason
  page = "",
  screenName = "",
}) => {
  if (!localStorage.adminToken) {
    triggerGa({
      category: category,
      action: action,
      label: platform,
      label2: status,
      label3: failReason,
      page: page,
      screenName: screenName,
    });
  }
};

export const setUserPropertiesGa = (property_params = {}) => {
  const analytics = getAnalytics();
  setUserProperties(analytics, {
    ...property_params,
    platform: getPlatform(),
    app_build: getAppBuildVersion(),
    app_version: getWebAppVersion(),
    app_open_id: getAppSessionUuid(),
  });
};

export const getInstagramPostTypeLabel = (postType) => {
  switch (postType) {
    case POST_TYPES.INSTA_IMAGE:
      return GA_LABEL3.IG_POST;
    case POST_TYPES.INSTA_STORY:
      return GA_LABEL3.IG_STORY;
    case POST_TYPES.INSTA_REEL:
      return GA_LABEL3.IG_REEL;
    default:
      return "";
  }
};
